import React from 'react';
import { CreateBasketPayload } from '../../../../datasources/baskets/BasketsDataSource';
import { Basket } from '../../../../types/basket/Basket';
import { DialogBasket } from './dialogBasket';

type EditBasketDialogProps = {
  open: boolean;
  basket: Basket;
  onClose: () => void;
  loading?: boolean;
  error?: string;
  onConfirm: (
    basketId: number,
    payload: CreateBasketPayload
  ) => void | Promise<void>;
};

export const EditBasketDialog: React.FC<EditBasketDialogProps> = ({
  open,
  basket,
  onClose,
  loading = false,
  error,
  onConfirm,
}) => (
  <DialogBasket
    open={open}
    mode="edit"
    onClose={onClose}
    loading={loading}
    error={error}
    initialBasket={basket}
    canConfirm
    onConfirm={(payload) => onConfirm(basket.id, payload)}
  />
);
